import { useEffect, useRef, DependencyList } from 'react';

const useDidUpdateEffect = (func: () => void, deps: DependencyList) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export default useDidUpdateEffect;
